import React from 'react'
import {createContext, useContext} from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const foundUser = JSON.parse(document.getElementById('app').dataset.currentUser || null);
  const [user, setUser] = React.useState(foundUser);

  console.debug('Found user', user)

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
}

const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };